/* Pop Toyzz: ilk ziyarette dili tarayıcıya, ülkeyi (para birimini) IP konumuna göre seçer (3 Kasım 2026).
   Shopify'ın browsing_context_suggestions.json yanıtını kullanır; Shopify planımız ülkeyi kendiliğinden seçmiyor.
   - Yalnız bir kez çalışır (localStorage 'pt_loc_set'); ziyaretçi header'daki seçiciyle seçim yaptıysa hiç çalışmaz.
   - Dil yalnız çevirisi tam olan dillere geçer (PT_LANGS); diğer tarayıcı dillerinde site İngilizce kalır.
   - Arama motoru botlarında ve otomasyon tarayıcılarında çalışmaz. */
(function () {
  var PT_LANGS = ['en', 'es', 'de', 'fr', 'tr'];
  var KEY = 'pt_loc_set';
  try {
    if (localStorage.getItem(KEY)) return;
  } catch (e) { return; }
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|preview|facebookexternalhit/i.test(navigator.userAgent)) return;
  if (!window.Shopify || !window.fetch) return;
  if (/^\/(checkouts|account|cart)/.test(location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2,4})?(?=\/)/i, ''))) return;

  var curLang = (Shopify.locale || 'en').toLowerCase();
  var curCountry = (Shopify.country || '').toUpperCase();
  var root = (Shopify.routes && Shopify.routes.root) || '/';

  function browserLang() {
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || 'en'];
    for (var i = 0; i < list.length; i++) {
      var code = String(list[i] || '').toLowerCase().split('-')[0];
      if (PT_LANGS.indexOf(code) !== -1) return code;
    }
    return 'en';
  }

  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      var country = detected ? String(detected).toUpperCase() : curCountry;
      // Adres zaten bir dil içeriyorsa (ör. reklamdan /es) dile dokunma; yalnız ana (İngilizce) adreste tarayıcı diline geç
      var lang = root === '/' ? browserLang() : curLang;
      try { localStorage.setItem(KEY, 'auto'); } catch (e) {}
      if (country === curCountry && lang === curLang) return;
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = root + 'localization';
      f.hidden = true;
      [['_method', 'PUT'], ['country_code', country || curCountry], ['language_code', lang]].forEach(function (p) {
        var i = document.createElement('input');
        i.name = p[0]; i.value = p[1];
        f.appendChild(i);
      });
      document.body.appendChild(f);
      f.submit();
    })
    .catch(function () {});
})();
